(ns ui.components.reorder-controls.view
  "Move-to-top / up / down / remove, as one control group.

   This existed five times over, copy-pasted: twice in the survey block
   editor, twice in the template editor and once in the question creator.
   Identical markup each time, differing only in which events it dispatched -
   so every fix to it fixed one copy. None of the five named its buttons, and
   one of them passed `:disabled` where the button component reads
   `:disabled?`, so its first row could be moved up past the top."
  (:require
   [common.localization :as loc]
   [ui.components.button.view :as button]))

(defn view
  "`first?` and `last?` disable the moves that would go nowhere. Each label
   defaults to a generic one and can be overridden where the surface can say
   something more specific than \"Remove\"."
  [{:keys [first? last? disabled?
           on-move-to-top on-move-up on-move-down on-remove
           move-to-top-label move-up-label move-down-label remove-label]}]
  [:div
   {:class "flex items-center justify-end gap-1"}
   (let [label (or move-to-top-label (loc/tr :reorder/move-to-top))]
     [button/square-secondary-open
      {:disabled?  (or disabled? first?)
       :tooltip    label
       :aria-label label
       :on-click   on-move-to-top}
      [:i.fa.fa-arrow-to-top]])
   (let [label (or move-up-label (loc/tr :reorder/move-up))]
     [button/square-secondary-open
      {:disabled?  (or disabled? first?)
       :tooltip    label
       :aria-label label
       :on-click   on-move-up}
      [:i.fa.fa-arrow-up]])
   (let [label (or move-down-label (loc/tr :reorder/move-down))]
     [button/square-secondary-open
      {:disabled?  (or disabled? last?)
       :tooltip    label
       :aria-label label
       :on-click   on-move-down}
      [:i.fa.fa-arrow-down]])
   (let [label (or remove-label (loc/tr :reorder/remove))]
     [button/square-secondary-open
      {:disabled?  disabled?
       :tooltip    label
       :aria-label label
       :on-click   on-remove}
      [:i.fa.fa-times-circle]])])
